














































































































































































import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';

import Builder from '@/utils/Builder';
import RiskResources from '@/services/RiskResources';

@Component({
	name: 'CommonFactors',
})
export default class CommonFactors extends Vue {
	@State('page', { namespace: 'RiskResources' }) private page;
	private Builder: typeof Builder = Builder;
	private RiskResources: typeof RiskResources = RiskResources;

	private clinicalSpecialtyFilter: number[] = [];
	private riskManagementIssueFilter: number[] = [];

	get magazines() {
		const magazines = this.page.acf.magazines.slice(0);

		magazines.shift();

		return magazines;
	}

	get latestMagazine() {
		const magazines = this.page.acf.magazines.slice(0, 1);

		return magazines[0];
	}
}
